export default "__VITE_ASSET__db1c3d52__"